import { styled } from '@abyss/web/tools/styled';

export const PreferredProviderMobile = styled('div', {
  backgroundColor: '$success2',
  fontSize: '12.64px',
  display: 'flex',
  width: 'fit-content',
  borderRadius: '8px 8px 0px 0px',
  marginLeft: '8px',
});

export const PreferredProviderWeb = styled('div', {
  backgroundColor: '$success2',
  width: 'fit-content',
  fontSize: '12.64px',
  display: 'flex',
  borderRadius: '8px 8px 0px 0px',
  marginLeft: '8px',
});
export const PreferredProviderWebUMR = styled('div', {
  backgroundColor: '$success2',
  width: 'fit-content',
  fontSize: '12.64px',
  display: 'flex',
  borderRadius: '8px 8px 0px 0px',
  alignItems: 'center',
});

export const GreenDiamond = styled('div', {
  marginTop: '5px',
  marginLeft: '4px',
});
